import type { HttpErrorFilterFn } from './http-error.models';

export const abortErrorFilter: HttpErrorFilterFn = (error) => {
  return error?.status === 0 && error?.error?.name === 'AbortError';
};
